import React from 'react';
import SaleTeamForm from './form';
import {notification} from 'antd';
import history from '../../modules/History';
import {addToSaleTeamItem} from '../../modules/Api';

class addSaleTeamItem extends React.Component {
    constructor() {
        super();
        var end = new Date();
        end.setHours(23,59,58);
        this.state = {
            data: {
                expiration_date: end
            },
            submitted: false,
            
        }

    }
    submit(values) {
        if(this.state.submitted){
            return;
        }
        this.setState({submitted: true});
        const formData = values;
        addToSaleTeamItem(formData, (res) => {
            this.setState({submitted:false});
            if(res.status && res.status==200) {
                notification.open({
                    message: `ایمیل با موفقیت اضافه شد!`,
                    description: ``
                });
                history.item.push(`/sale-team`);
            }
            else{
                notification.open({
                    message: 'خطایی رخ داده است.',
                    description: res.message
                });
            }
        });
    }
    render() {
        return (<div><SaleTeamForm initialData={this.state.data} submit={this.submit.bind(this)} submitted={this.state.submitted}/></div>);
    }
}

export default addSaleTeamItem;


// WEBPACK FOOTER //
// ./src/containers/SaleTeam/add.js